import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-switch-green',
  templateUrl: './switch-green.component.html',
  styleUrls: ['./switch-green.component.css'],
})
export class SwitchGreenComponent {
  // to check enable and disable switch
  @Input() checked: boolean;
  // label of the switch
  @Input() label: string;
  // updating th checked value when its is changed
  @Output() checkedChange = new EventEmitter<boolean>();

  @Input() disabled: boolean = false;

  @Input() isLabelBefore: boolean = false;

  onToggleChange() {
    this.checkedChange.emit(this.checked);
  }
}
